import axios from 'axios'
import router from '@/router' // 引入 router 实例
import { useAuthStore } from '@/stores/authStore'

const instance = axios.create({
  baseURL: '/api', // 使用代理配置的前缀
  timeout: 50000 // 请求超时时间
})

// 请求拦截器
instance.interceptors.request.use(
  (config) => {
    // 在这里可以添加请求头，例如 token
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
instance.interceptors.response.use(
  (response) => {
    const { data } = response

    // 假设响应数据中包含 code 字段
    if (data.code !== 200 && data.code !== 0) {
      // 如果 code 为 600，跳转到登录页面
      if (data.code === 600) {
        const authStore = useAuthStore()
        // 清除登录状态（例如清除 token）
        authStore.clearToken()
        // 跳转到登录页面
        router.push({ path: '/login' })
      }
      // 返回一个错误
      return Promise.reject(new Error(data.message || '请求失败'))
    }
    return data // 直接返回数据
  },
  (error) => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

export default instance
